import { translate } from '../../ContentTranslation';
import React, { Component } from 'react';
import { Tooltip } from 'reactstrap';
import Img from '../../StableImage';
import Hand from './Hand';
import Enemies from './Enemies';
import Champion from './Champion';
import Companion from './Companion';
import SceneButton from '../../components/buttons/SceneButton';
import './Fight.css';
import { read } from '../../TextManager';

export default class Fight extends Component {

  state = {

    tooltip: null
  }

  toggleTooltip (tooltip, touch) {

    if (tooltip === this.state.tooltip && this.state.tooltipDate && new Date() - this.state.tooltipDate < 500)
      return;

    if (touch) {
      
      if (this.tooltipTimeout)
        clearTimeout(this.tooltipTimeout);

      this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip, tooltipDate: new Date()});
      this.tooltipTimeout = setTimeout(() => this.toggleTooltip(null), 3000);
      return;
    }

    this.setState({tooltip: tooltip === this.state.tooltip ? null : tooltip});
  }

  render () {

    let tooltips = []

    let src = this.props.src;
    let manager = this.props.manager;
    let tension = src.player.statuses.find(status => status.model.key === "tension");
    let overgrowth = src.player.statuses.find(status => status.model.key === "overgrowth");
    let photosynthesis = src.player.getStatusValue ? src.player.getStatusValue("photosynthesis") : 0;
    let overgrowthManaPerTurn = 3 + photosynthesis / 3;
    let overgrowthEfficiency = 1 + (src.run.champion.getPassive("overgrowthbonus") || 0);
    let overgrowthRatio = overgrowth && overgrowthManaPerTurn ? overgrowth.value / overgrowthManaPerTurn * overgrowthEfficiency : 0;
    let overgrowthPercent = Math.round(overgrowthRatio * 100);

    return (
      <div className={"fight-scene " + (manager.controller.name)}>
        <Champion src={src.player} onSelect={() => {}}/>
        {
          src.run.companion &&
          <Companion src={src.run.companion} onSelect={() => {}}/>
        }
        <div className="card-autocast"><img src="/images/nothing.png"/></div>
        <div className="card-autocast"><img src="/images/nothing.png"/></div>
        <Enemies
          hoverTarget={enemy => {
            if (this.state.enemy !== enemy)
              this.setState({hoverTarget: enemy});
          }}
          targeting={manager.targeting ? manager.controller.selected : undefined}
          src={src.slots ? src.slots : src.enemies.map(enemy => ({ enemy }))}
          onSelect={manager.onSelectEntity.bind(manager)}/>
        {
          src.run.champion.model.key === 2 &&
          <div id="hud-tension" className="mana-count-wrapper">
            <Img src="/images/statuses/Tension.png"/>
            <div className="mana-count">{tension ? tension.value : 0}</div>
          </div>
        }
        { src.run.champion.model.key === 2 && <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "hud-tension"} target="hud-tension" toggle={() => this.toggleTooltip("hud-tension")}><b>{tension ? tension.model.name : "Tension"}</b><br/>{tension ? tension.model.effect : translate("Fuels various effects.")}</Tooltip> }
        { src.run.champion.model.key === 4 && <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "hud-overgrowth"} target="hud-overgrowth" toggle={() => this.toggleTooltip("hud-overgrowth")}><b>{overgrowth ? overgrowth.model.name : "Overgrowth"}</b><br/>{overgrowth ? overgrowth.model.effect : translate("Damage and block are increased by your Overgrowth to mana per turn ratio. If higher than your mana at end of turn, drops to that value.")}</Tooltip> }
        <div id="mana" onPointerDown={e => this.toggleTooltip("mana", e.pointerType === "touch")} className="mana-count-wrapper">
          <Img src="/images/mana.png"/>
          <div className="mana-count">{src.mana}</div>
        </div>
        <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "mana"} target="mana" toggle={() => this.toggleTooltip("mana")}><b>{read('scene/mana')}</b><br/>{read('scene/manainfo')}</Tooltip>
        {
          src.run.champion.model.key === 4 &&
          <div id="hud-overgrowth" className={"mana-count-wrapper" + (overgrowth ? " visible" : "")}>
            <Img src="/images/overgrowth.png"/>
            <div className="mana-count">{overgrowth ? overgrowth.value : 0}</div>
            <div className="overgrowth-ratio">+{overgrowthPercent}%</div>
          </div>
        }
        <Hand
          targeting={manager.targeting}
          target={this.state.hoverTarget}
          overgrowthPercent={src.run.champion.model.key === 4 && overgrowth ? overgrowthPercent : undefined}
          src={src.hand}
          manager={manager}
          onFocus={model => this.setState({tooltip: null, focus: model})}
          onSelect={manager.onSelectCard.bind(manager)}
          onSkill={manager.onSelectSkill.bind(manager)}
          getHalo={card => manager.controller?.cardHalo?.(card)}
          getSkillHalo={() => manager.controller?.skillHalo?.()}
          />
        <div className="locations-info">
          <div id="hand-info" className="location-info hand-info">
            <Img className="location-icon" src="/images/hand.png"/>
            <div className="location-count hand-count">{src.hand.count}</div>
          </div>
          <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "hand-info"} target="hand-info" toggle={() => this.toggleTooltip("hand-info")}><b>{read('scene/hand')}</b><br/>{read('scene/handinfo')}</Tooltip>
          <div id="deck-info" className="location-info deck-info" onClick={() => manager.setState({deckviewer: src.deck.cards.map(c => c.model)})}>
            <div className="card-shuffle-deck"><img src="/images/nothing.png"/></div>
            <div className="card-shuffle-deck"><img src="/images/nothing.png"/></div>
            <Img className="location-icon" src="/images/deck.png"/>
            <div className="location-count deck-count">{src.deck.count}</div>
            <Img className="location-next" src="/images/arrowhead.png"/>
            {
              src.run.champion.model.key === 3 &&
              <div className={"game-milk"}>
                <Img className="game-milk-icon" src="/images/statuses/Milk bottle.png"/>
                <div className="game-milk-text">{src.deck.cards.filter(c => c.model.key === "milk-bottle").length}</div>
              </div>
            }
          </div>
          <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "deck-info"} target="deck-info" toggle={() => this.toggleTooltip("deck-info")}><b>{read('scene/deck')}</b><br/>{read('scene/deckinfo')}</Tooltip>
          <div id="supply-info" className="location-info supply-info" onClick={() => manager.setState({deckviewer: src.supply.cards.map(c => c.model)})}>
            <div className="card-shuffle-deck"><img src="/images/nothing.png"/></div>
            <div className="card-shuffle-deck"><img src="/images/nothing.png"/></div>
            <Img className="location-icon" src="/images/supply.png"/>
            <div className="location-count supply-count">{src.supply.count}</div>
            <Img className="location-next" src="/images/arrowhead.png"/>
            {
              src.run.champion.model.key === 3 &&
              <div className={"game-milk"}>
                <Img className="game-milk-icon" src="/images/statuses/Milk bottle.png"/>
                <div className="game-milk-text">{src.supply.cards.filter(c => c.model.key === "milk-bottle").length}</div>
              </div>
            }
          </div>
          <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "supply-info"} target="supply-info" toggle={() => this.toggleTooltip("supply-info")}><b>{read('scene/supply')}</b><br/>{read('scene/supplyinfo')}</Tooltip>
          <div id="discard-info" className="location-info discard-info" onClick={() => manager.setState({deckviewer: src.discard.cards.map(c => c.model)})}>
            <div className="card-shuffle-deck"><img src="/images/nothing.png"/></div>
            <div className="card-shuffle-deck"><img src="/images/nothing.png"/></div>
            <Img className="location-icon" src="/images/discard.png"/>
            <div className="location-count discard-count">{src.discard.count}</div>
            <Img className="location-next" src="/images/arrowhead.png"/>
            {
              src.run.champion.model.key === 3 &&
              <div className={"game-milk"}>
                <Img className="game-milk-icon" src="/images/statuses/Milk bottle.png"/>
                <div className="game-milk-text">{src.discard.cards.filter(c => c.model.key === "milk-bottle").length}</div>
              </div>
            }
          </div>
          <Tooltip className="tooltip" placement="top" isOpen={this.state.tooltip === "discard-info"} target="discard-info" toggle={() => this.toggleTooltip("discard-info")}><b>{read('scene/discard')}</b><br/>{read('scene/discardinfo')}</Tooltip>
        </div>
        <div className={"fight-end-turn" + (src.player.hasStatus("timewarp") ? " fight-extra-turn" : "")}><SceneButton onClick={() => manager.endTurn()}>{ src.player.hasStatus("timewarp") ? read('scene/extraturn') : read('scene/endturn') }</SceneButton></div>
      </div>
    );
  }
}

